import { Injectable } from '@angular/core';
import { ApiV2Service } from 'app/common/services/api-v2.service';
import { IMigrationRequest } from 'app/common/models/migration-request.model';

@Injectable()
export class AdminDashboardService {

  constructor(
    private apiV2: ApiV2Service,
  ) {}

  startMigrate(request: IMigrationRequest) {
    return this.apiV2.adminDashboard.startMigrate(request); 
  }
  getInfoMigrate() {
    return this.apiV2.adminDashboard.getInfoMigrate(); 
  }
}
